import axios from 'axios'
import { API_URL } from '../constants';

const NOTE_API_URL = `${API_URL}/notes`;

class NoteDataService {

    retrieveNotesByOrder(orderId) {
        const token = sessionStorage.getItem('token');
        return axios.get(`${NOTE_API_URL}/findNotesByOrder/${orderId}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveNotesByWorkOrder(workOrderId) {
        const token = sessionStorage.getItem('token');
        return axios.get(`${NOTE_API_URL}/findNotesByWorkOrder/${workOrderId}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }
}

export default new NoteDataService()